<template>
  <div v-if="outletInfo" class="cx-card cx-card-lg cx-margin-overview">
    <div style="display: flex; ">
      <h5 class="scoped-header no-break">{{ outletInfo.name }}</h5>
    </div>
    <div class="no-break">
      <div>{{ outletInfo.address }}, {{ outletInfo.zipCode }} {{ outletInfo.city }}</div>
      <div>({{ outletInfo.outletId }}) </div>
    </div>
    <figure>
      <img :src="outletInfo.image" class="local-image" alt="Description of Image">
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    outletInfo:             { type: Object, default: () => undefined },
    theme:                  { type: String, default: () => 'light' },
  }
}
</script>

<style scoped>

.cx-margin-overview figure img {
  overflow: hidden;
  max-height: 14rem;
  width: 100%;
  object-fit: cover;
  aspect-ratio: 4/3;
}

h5 {
  line-height: 1.2;
  margin: 0rem;
}

.cx-margin-overview {
  padding: 1.0rem;
}

.scoped-header{
  font-weight: 600;
  font-size: 16pt;
  padding-right: 1rem;
}

</style>